/**
 * Throttle to prevent function overload
 * @param {fn} fn - Function
 * @param {ms} ms - Milliseconds
 */
const throttle = (fn, ms) => {
    let time;
    let last = 0;
    return () => {
        const a = arguments;
        const t = this;
        const now = +new Date();
        const exe = () => {
            last = now;
            fn.apply(t, a);
        };
        clearTimeout(time);
        now >= last + ms ? exe() : (time = setTimeout(exe, ms));
    };
};

const setCookie = (cName, cValue, expDays) => {
    let date = new Date();

    date.setTime(date.getTime() + (parseInt(expDays) * 24 * 60 * 60 * 1000));

    const expires = "expires=" + date.toUTCString();

    document.cookie = cName + "=" + cValue + "; " + expires + "; path=/";
}

const getCookie = (cName) => {
    const name = cName + "=";
    const cDecoded = decodeURIComponent(document.cookie);
    const cArr = cDecoded .split('; ');
    let res;

    cArr.forEach(val => {
        if (val.indexOf(name) === 0) res = val.substring(name.length);
    })

    return res;
}

export {
    throttle,
    setCookie,
    getCookie,
};
